/* eslint-disable max-len */
import { FilterAndSortField as AscOrdersFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/aftersales_order/request/model/FilterAndSortField';
import { AftersalesOrderResponse } from '@1po/1po-bff-fe-spec/generated/aftersales_order/response/AftersalesOrderResponse';
import { GetVehicleInfoResponse } from '@1po/1po-bff-fe-spec/generated/catalog/search_vehicle/response/GetVehicleInfoResponse';
import { FilterAndSortField as ClaimsFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/claim/request/model/FilterAndSortField';
import { GetClaimAttachmentDownloadUrlResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/GetClaimAttachmentDownloadUrlResponse';
import { AddCustomItemResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/GetClaimAttachmentUploadUrlResponse';
import { GetGarageClaimPageResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/GetGarageClaimPageResponse';
import { RequestClaimResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/SendClaimResponse';
import { FilterAndSort } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterAndSort';
import { FilterArray } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterArray';
import { SortBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/SortBy';
import { REQUEST_CLAIM_ERROR } from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { WsResponse } from '@1po/1po-bff-fe-spec/generated/common/WsResponse';
import { AddAscOrderItemToDepositReturnListResponse } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/response/AddAscOrderItemToDepositReturnListResponse';
import { GetCurrentDepositReturnListResponse } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/response/GetCurrentDepositReturnListResponse';
import { AddAscOrderItemToExadisReturnListResponse } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/response/AddAscOrderItemToExadisReturnListResponse';
import { GetCurrentExadisReturnListResponse } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/response/GetCurrentExadisReturnListResponse';
import { FilterAndSortField as MyClientsOrderFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/my_clients_order/request/model/FilterAndSortField';
import { MyClientsOrderDetailResponse } from '@1po/1po-bff-fe-spec/generated/my_clients_order/response/MyClientsOrderDetailResponse';
import { MyClientsOrderResponse } from '@1po/1po-bff-fe-spec/generated/my_clients_order/response/MyClientsOrderResponse';
import { FilterAndSortField } from '@1po/1po-bff-fe-spec/generated/order/request/model/FilterAndSortField';
import { CheckoutOrderResponse } from '@1po/1po-bff-fe-spec/generated/order/response/CheckoutOrderResponse';
import { GetDealerOrderPageResponse } from '@1po/1po-bff-fe-spec/generated/order/response/GetDealerOrderPageResponse';
import { GetExternalOrdersResponse } from '@1po/1po-bff-fe-spec/generated/order/response/GetExternalOrdersResponse';
import { GetGarageUsersWithOrderResponse } from '@1po/1po-bff-fe-spec/generated/order/response/GetGarageUsersWithOrderResponse';
import { GetOrderByIdResponse } from '@1po/1po-bff-fe-spec/generated/order/response/GetOrderByIdResponse';
import { OrderStatusUpdateResponse } from '@1po/1po-bff-fe-spec/generated/order/response/OrderStatusUpdateResponse';
import { ReAddOrderReferencesToBasketResponse } from '@1po/1po-bff-fe-spec/generated/order/response/ReAddOrderReferencesToBasketResponse';

import { call, delay, put, race, take, takeEvery } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { v4 as uuidv4 } from 'uuid';
import { RootState } from 'app/AppStore';
import { getBasketId } from 'domains/basket/Basket.store';
import { sendGetVehicleInfoByVrnRequest } from 'domains/catalog/Catalog.api';
import {
  sendAddAscOrderItemToExadisReturnListRequest,
  sendCheckoutOrderRequest,
  sendDownloadDealerDeliveryTracksRequest,
  sendExternalOrderListRequest,
  sendGetAscOrders,
  sendGetClaimsAttachmentDownloadUrl,
  sendGetClaimsAttachmentUploadUrl,
  sendGetClaimsRequest,
  sendGetGarageUsersWithOrderRequest,
  sendGetMyClientsOrderDetail,
  sendGetMyClientsOrders,
  sendGetOrderById,
  sendOrderClaim,
  sendReAddReferencesToBasket,
  sendGetCurrentExadisReturnListRequest,
  sendRemoveItemsFromExadisReturnListRequest,
  sendAddAscOrderItemToDepositReturnListRequest,
  sendGetCurrentDepositReturnListRequest,
  sendRemoveItemsFromDepositReturnListRequest,
  sendSubscribeOrderUpdates,
  sendUnsubscribeOrderUpdates,
  subscribeSap2bClaimsResponses,
} from 'domains/order/Order.api';
import {
  getAscFilterArray,
  getClaimsFilterArray,
  getMyClientsFilterArray,
  mapAdditionalClaim,
  mapClaim,
} from 'domains/order/Order.mapper';
import * as actions from 'domains/order/Order.store';
import {
  addClaimUploadAttachment,
  addExternalOrdersData,
  addInProgressOrder,
  addInProgressOrdersData,
  addOrderIdToPendingAddToBasketRequests,
  clearOrderClaimAttachmentDownloading,
  clearCheckoutStatus,
  getAllInProgressOrdersFilters,
  getAscOrdersFilters,
  getClaimsFilters,
  getClaimsUploadAttachment,
  getInProgressOrdersCursor,
  getInProgressOrdersSort,
  getMyClientsOrdersFilters,
  getMyClientsOrdersPagination,
  getOrderClaimForm,
  getDepositReturnClaimLineKeys,
  getExadisReturnClaimLineKeys,
  getIsExadisReturnListFull,
  getIsDepositReturnListFull,
  initOrderClaimForm,
  removeOrderIdFromPendingAddToBasketRequests,
  resetAscOrders,
  resetInProgressOrdersForNewSearch,
  resetLoadedClaims,
  setAscOrders,
  setCheckoutStatus,
  setExternalOrdersNoDataStatus,
  setGarageUsersWithOrder,
  setOrderClaimAttachmentDownloading,
  setInProgressIsLoading,
  setInProgressOrderSearchStatus,
  setInProgressOrdersNotFound,
  setLoadedClaims,
  setLoadedClaimsSearchStatus,
  setMyClientsOrderDetail,
  setMyClientsOrderDetailStatus,
  setMyClientsOrders,
  setMyClientsOrdersPagination,
  setMyClientsOrdersStatus,
  setOrderClaimForm,
  setOrderClaimStatus,
  setExadisReturnList,
  setExadisReturnListAddItemStatus,
  setExadisReturnListStatus,
  setDepositReturnList,
  setDepositReturnListAddItemStatus,
  setDepositReturnListStatus,
  setVrnSearchLoading,
  updateOrderStatus,
} from 'domains/order/Order.store';
import {
  ClaimsFilterFields,
  MULTI_ITEMS_DEPOSIT_RETURN,
  MULTI_ITEMS_EXADIS_RETURN,
  MyClientsOrderFilterAndSortFieldLocal,
  sortOptionsMapping,
} from 'domains/order/Order.types';
import {
  DEFAULT_COUNTRY,
  getCurrency,
  getTradingProfile,
  getUserContext,
  getUserCountry,
  getUserRights,
  UserRole,
} from 'domains/user';
import { notifyTop } from 'UI';
import {
  AppTranslation,
  dataUrlToBlob,
  ERROR,
  FOUND,
  LOADING,
  NOT_FOUND,
  sagaGuard,
  select,
  triggerBlobDownload,
} from 'utils';
import { Country } from 'utils/i18n/Country';

export function* checkoutOrderRequestSaga({
  payload,
}: ReturnType<typeof actions.checkoutOrderRequestSaga>): SagaIterator {
  const currency = yield* select(getCurrency);
  const basketId = yield* select(getBasketId);
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.isComplete()) return;
  if (!basketId) return;
  yield put(clearCheckoutStatus());
  const userContext = yield* select(getUserContext);
  yield put(
    sendCheckoutOrderRequest({
      ...payload,
      basketId,
      userContext,
      currency,
    }),
  );
}

export function* checkoutOrderResponseSaga(action: WsResponse<CheckoutOrderResponse>): SagaIterator {
  if (!action.payload) {
    yield put(setCheckoutStatus({ placedOrders: [], failedOrders: [], ordersOverallStatus: 'NOT_PLACED' }));
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        'catalog.universal_products.basket.minimum_quantity.notification.first_line',
        'Minimum order quantity of 200L is not reached for Castrol Oil reference(s).',
      ),
      AppTranslation.t(
        'catalog.universal_products.basket.minimum_quantity.notification.second_line',
        'Please adjust quantities and try again.',
      ),
    );
    return;
  }

  yield put(setCheckoutStatus(action.payload));

  if (action.payload.placedOrders?.length === 0) {
    return;
  }

  // Re-subscribe after checkout so the new order appears in My Orders.
  // A short delay is needed because the backend projection (OrderEventHandler.on(OrderCreated))
  // runs asynchronously after the command handler returns. Without the delay, the subscription
  // query may run before the order is projected into MongoDB and the initial response won't
  // include the new order (no subscription update is emitted on OrderCreated).
  yield delay(2000);
  yield put(actions.orderSubscriptionSaga());
}

export const DOWNLOAD_DEALER_DELIVERY_TRACKS_REQUEST_KEY = 'R1ExportInProgressOrders';

export function* downloadDealerOrdersRequestSaga(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.buyerId) {
    yield put(setInProgressOrdersNotFound());
    return;
  }

  yield put(
    sendDownloadDealerDeliveryTracksRequest({
      fileKey: DOWNLOAD_DEALER_DELIVERY_TRACKS_REQUEST_KEY,
    }),
  );
}

export function* fetchDealerOrdersResponseSaga(action: WsResponse<GetDealerOrderPageResponse>): SagaIterator {
  if (action.payload) {
    const { orderItems, cursor, hasMore } = action.payload;
    yield put(addInProgressOrdersData({ orderItems, cursor, hasMore }));
    yield put(setInProgressIsLoading(false));
  }
}

export function* fetchDealerExternalOrdersRequestSaga(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.isComplete()) return;
  yield put(setExternalOrdersNoDataStatus(LOADING));
  yield put(sendExternalOrderListRequest());
}

export function* fetchDealerExternalOrdersResponseSaga(action: WsResponse<GetExternalOrdersResponse>): SagaIterator {
  if (action.payload) {
    yield put(addExternalOrdersData(action.payload.orderItems));
  }
}

export function* fetchOrderByIdResponseSaga(action: WsResponse<GetOrderByIdResponse>): SagaIterator {
  if (action.payload) {
    const { orderItem } = action.payload;
    yield put(addInProgressOrder(orderItem));
  }
}

export function* fetchOrderByIdRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchOrderByIdRequestSaga>): SagaIterator {
  yield put(setInProgressOrderSearchStatus({ orderId: payload, status: LOADING }));
  yield put(
    sendGetOrderById({
      orderId: payload,
    }),
  );
}

export function* reAddOrderReferencesToBasketRequestSaga({
  payload,
}: ReturnType<typeof actions.reAddOrderReferencesToBasketRequestSaga>): SagaIterator {
  yield put(addOrderIdToPendingAddToBasketRequests(payload));
  yield put(
    sendReAddReferencesToBasket({
      orderId: payload,
    }),
  );
}

export function* sendOrderClaimRequestSaga(): SagaIterator {
  const claimForm = yield* select(getOrderClaimForm);
  yield put(setOrderClaimStatus(LOADING));
  yield put(sendOrderClaim(mapClaim(claimForm)));

  if (claimForm.reason !== 'Y05') {
    return;
  }

  const { response, error }: { response?: WsResponse<RequestClaimResponse>; error?: unknown } = yield race({
    response: take(actions.requestClaimResponseSaga.type),
    error: take(REQUEST_CLAIM_ERROR),
  });

  if (!response || error) {
    return;
  }

  const linkedClaimId = response.payload?.claimId;
  if (linkedClaimId) {
    yield put(sendOrderClaim(mapAdditionalClaim(claimForm, linkedClaimId)));
  }
}

export function* subscribeSap2bClaimMessages(): SagaIterator {
  yield put(subscribeSap2bClaimsResponses());
}

export function* subscribeSap2bClaimMessagesResponse(): SagaIterator {
  const claimForm = yield* select(getOrderClaimForm);
  const lineKeys = yield* select(getExadisReturnClaimLineKeys);
  const depositReturnLineKeys = yield* select(getDepositReturnClaimLineKeys);
  yield call(notifyTop, 'success', AppTranslation.t('order.claim.created', 'Claim created'));
  yield put(actions.fetchClaimsRequestSaga({ cursor: undefined }));
  yield put(setOrderClaimStatus(undefined));
  yield put(initOrderClaimForm());
  if (claimForm.formType === MULTI_ITEMS_EXADIS_RETURN && lineKeys.length) {
    yield put(actions.removeExadisReturnListItemsRequestSaga({ lineKeys }));
  }
  if (claimForm.formType === MULTI_ITEMS_DEPOSIT_RETURN && depositReturnLineKeys.length) {
    yield put(actions.removeDepositReturnListItemsRequestSaga({ lineKeys: depositReturnLineKeys }));
  }
}

export function* fetchClaimsRequestSaga({ payload }: ReturnType<typeof actions.fetchClaimsRequestSaga>): SagaIterator {
  const claimsFilters = yield* select(getClaimsFilters);
  const { cursor } = payload;
  const filterAndSort: FilterAndSort<FilterAndSortField> = {
    sorts: [new SortBy(ClaimsFilterFields.CREATED_AT, 'DESC')],
    filter:
      claimsFilters.size > 0
        ? new FilterArray<ClaimsFilterAndSortField>('AND', getClaimsFilterArray(claimsFilters))
        : undefined,
    cursor,
  };
  if (!cursor) {
    yield put(resetLoadedClaims());
  }
  yield put(setLoadedClaimsSearchStatus(LOADING));
  yield put(
    sendGetClaimsRequest({
      filterAndSort,
    }),
  );
}

export function* fetchClaimsResponseSaga(action: WsResponse<GetGarageClaimPageResponse>): SagaIterator {
  yield put(setLoadedClaims(action.payload));
}

export function* fetchAscOrdersRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchAscOrdersRequestSaga>): SagaIterator {
  const ascFilters = yield* select(getAscOrdersFilters);
  const { cursor } = payload;
  const filterAndSort: FilterAndSort<AscOrdersFilterAndSortField> = {
    sorts: [new SortBy('DATE', 'DESC')],
    filter:
      ascFilters.size > 0
        ? new FilterArray<AscOrdersFilterAndSortField>('AND', getAscFilterArray(ascFilters))
        : undefined,
    cursor,
  };
  if (!cursor) {
    yield put(resetAscOrders(LOADING));
  }
  yield put(sendGetAscOrders({ filterAndSort }));
}

export function* fetchAscOrdersResponseSaga(action: WsResponse<AftersalesOrderResponse>): SagaIterator {
  const userRights = yield* select(getUserRights);
  if (userRights.includes(UserRole.R1_ORDER_AND_CLAIM)) {
    // prevent double loading and concating duplicated response
    yield put(resetAscOrders(LOADING));
  }
  yield put(setAscOrders(action.payload));
}

export function* fetchMyClientsOrdersRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchMyClientsOrdersRequestSaga>): SagaIterator {
  const myClientsFilters = yield* select(getMyClientsOrdersFilters);
  const pagination = yield* select(getMyClientsOrdersPagination);
  const { page = pagination.page, pageSize = pagination.pageSize } = payload;
  const filterAndSort: FilterAndSort<MyClientsOrderFilterAndSortField> = {
    sorts: [new SortBy('ORDER_NUMBER', 'DESC')],
    filter:
      myClientsFilters.size > 0
        ? new FilterArray<MyClientsOrderFilterAndSortField>('AND', getMyClientsFilterArray(myClientsFilters))
        : undefined,
  };
  yield put(setMyClientsOrdersStatus(LOADING));
  yield put(setMyClientsOrdersPagination({ page, pageSize }));
  yield put(sendGetMyClientsOrders({ filterAndSort, page, pageSize }));
}

export function* fetchMyClientsOrdersResponseSaga(action: WsResponse<MyClientsOrderResponse>): SagaIterator {
  yield put(setMyClientsOrders(action.payload));
}

export function* fetchMyClientsOrderDetailRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchMyClientsOrderDetailRequestSaga>): SagaIterator {
  yield put(setMyClientsOrderDetailStatus(LOADING));
  yield put(sendGetMyClientsOrderDetail({ orderNumber: payload.orderNumber }));
}

export function* fetchMyClientsOrderDetailResponseSaga(action: WsResponse<MyClientsOrderDetailResponse>): SagaIterator {
  yield put(setMyClientsOrderDetail(action.payload));
}

export function* fetchExadisReturnListRequestSaga(
  _action: ReturnType<typeof actions.fetchExadisReturnListRequestSaga>,
): SagaIterator {
  yield put(setExadisReturnListStatus(LOADING));
  yield put(sendGetCurrentExadisReturnListRequest({}));
}

export function* fetchExadisReturnListResponseSaga(
  action: WsResponse<GetCurrentExadisReturnListResponse>,
): SagaIterator {
  if (action.payload?.lines) {
    yield put(
      setExadisReturnList({
        searchStatus: action.payload.lines.length > 0 ? FOUND : NOT_FOUND,
        data: action.payload.lines,
      }),
    );
    return;
  }

  yield put(setExadisReturnList({ searchStatus: ERROR, data: undefined }));
}

export function* removeExadisReturnListItemsRequestSaga(
  action: ReturnType<typeof actions.removeExadisReturnListItemsRequestSaga>,
): SagaIterator {
  const { lineKeys } = action.payload;
  if (!lineKeys.length) {
    return;
  }
  yield put(sendRemoveItemsFromExadisReturnListRequest({ lineKeys }));
}

export function* removeExadisReturnListItemsResponseSaga(): SagaIterator {
  yield put(actions.fetchExadisReturnListRequestSaga());
}

export function* addExadisReturnListItemRequestSaga(
  action: ReturnType<typeof actions.addExadisReturnListItemRequestSaga>,
): SagaIterator {
  const { payload } = action;
  const isFull = yield* select(getIsExadisReturnListFull);
  if (isFull) {
    yield put(setExadisReturnListAddItemStatus(ERROR));
    yield call(
      notifyTop,
      'error',
      AppTranslation.t('exadis_return_list.error.max_items.title', 'Return list is full'),
      AppTranslation.t(
        'exadis_return_list.error.max_items.description',
        'The return list can contain a maximum of 99 items. Please convert it into a claim before adding more items.',
      ),
    );
    return;
  }

  yield put(setExadisReturnListAddItemStatus(LOADING));
  yield put(sendAddAscOrderItemToExadisReturnListRequest(payload));
}

export function* addExadisReturnListItemResponseSaga(
  action: WsResponse<AddAscOrderItemToExadisReturnListResponse>,
): SagaIterator {
  const line = action.payload?.line;
  if (line) {
    yield put(actions.addExadisReturnListItem(line));
    yield put(setExadisReturnListAddItemStatus(FOUND));
    yield call(
      notifyTop,
      'success',
      AppTranslation.t('exadis_return_list.add_item.success.title', 'Item added to exadis return list'),
    );
  }
}

export function* fetchDepositReturnListRequestSaga(
  _action: ReturnType<typeof actions.fetchDepositReturnListRequestSaga>,
): SagaIterator {
  yield put(setDepositReturnListStatus(LOADING));
  yield put(sendGetCurrentDepositReturnListRequest({}));
}

export function* fetchDepositReturnListResponseSaga(
  action: WsResponse<GetCurrentDepositReturnListResponse>,
): SagaIterator {
  if (action.payload?.lines) {
    yield put(
      setDepositReturnList({
        searchStatus: action.payload.lines.length > 0 ? FOUND : NOT_FOUND,
        data: action.payload.lines,
      }),
    );
    return;
  }

  yield put(setDepositReturnList({ searchStatus: ERROR, data: undefined }));
}

export function* removeDepositReturnListItemsRequestSaga(
  action: ReturnType<typeof actions.removeDepositReturnListItemsRequestSaga>,
): SagaIterator {
  const { lineKeys } = action.payload;
  if (!lineKeys.length) {
    return;
  }
  yield put(sendRemoveItemsFromDepositReturnListRequest({ lineKeys }));
}

export function* removeDepositReturnListItemsResponseSaga(): SagaIterator {
  yield put(actions.fetchDepositReturnListRequestSaga());
}

export function* addDepositReturnListItemRequestSaga(
  action: ReturnType<typeof actions.addDepositReturnListItemRequestSaga>,
): SagaIterator {
  const { payload } = action;
  const isFull = yield* select(getIsDepositReturnListFull);
  if (isFull) {
    yield put(setDepositReturnListAddItemStatus(ERROR));
    yield call(
      notifyTop,
      'error',
      AppTranslation.t('deposit_return_list.error.max_items.title', 'Return list is full'),
      AppTranslation.t(
        'deposit_return_list.error.max_items.description',
        'The return list can contain a maximum of 99 items. Please convert it into a claim before adding more items.',
      ),
    );
    return;
  }

  yield put(setDepositReturnListAddItemStatus(LOADING));
  yield put(sendAddAscOrderItemToDepositReturnListRequest(payload));
}

export function* addDepositReturnListItemResponseSaga(
  action: WsResponse<AddAscOrderItemToDepositReturnListResponse>,
): SagaIterator {
  const line = action.payload?.line;
  if (line) {
    yield put(actions.addDepositReturnListItem(line));
    yield put(setDepositReturnListAddItemStatus(FOUND));
    yield call(
      notifyTop,
      'success',
      AppTranslation.t('deposit_return_list.add_item.success.title', 'Item added to deposit return list'),
    );
  }
}

export function* updateMyClientsOrdersFiltersAndRefetchSaga(
  action: PayloadAction<{ field: MyClientsOrderFilterAndSortFieldLocal; value: string }>,
): SagaIterator {
  const { field, value } = action.payload;

  yield put(actions.setMyClientsOrdersFilter({ field, value }));
  yield call(fetchMyClientsOrdersRequestSaga, actions.fetchMyClientsOrdersRequestSaga({ page: 1 }));
}

export function* fetchClaimDocumentUploadUrlRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchClaimDocumentUploadUrlRequestSaga>): SagaIterator {
  const { fileName } = payload;
  yield put(sendGetClaimsAttachmentUploadUrl({ fileName }));
}

export function* fetchClaimDocumentUploadUrlResponseSaga(action: WsResponse<AddCustomItemResponse>): SagaIterator {
  const { fileName, key, uploadUrl } = action.payload;
  const savedFile = yield* select((state: RootState) => getClaimsUploadAttachment(state, fileName));

  if (!savedFile?.base64) {
    return;
  }

  const putUploadError = () =>
    put(
      addClaimUploadAttachment({
        ...savedFile,
        status: 'error',
        error: AppTranslation.t(
          'common.file_upload.error.error_upload_to_url',
          'Error during uploading file to target URL',
        ),
      }),
    );

  try {
    const response: Response = yield call(fetch, uploadUrl, {
      method: 'PUT',
      body: savedFile.base64,
      headers: {
        'Content-Type': 'text/plain',
      },
    });

    if (response.ok) {
      yield put(
        addClaimUploadAttachment({
          ...savedFile,
          key,
          status: 'done',
        }),
      );
    } else {
      yield putUploadError();
    }
  } catch (error) {
    console.error(error);
    yield putUploadError();
  }
}

export function* fetchClaimDocumentDownloadUrlRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchClaimDocumentDownloadUrlRequestSaga>): SagaIterator {
  const { fileName, fileKey, fileUrl } = payload;
  if (fileKey) {
    yield put(setOrderClaimAttachmentDownloading(fileKey));
  }
  yield put(sendGetClaimsAttachmentDownloadUrl({ fileName, fileKey, fileUrl }));
}

async function resolveClaimAttachmentBlob(response: Response, fileName: string): Promise<void> {
  const blob: Blob = await response.blob();
  // Handle legacy uploads where files were stored as data URL text in S3
  if (blob.type.startsWith('text/')) {
    const text: string = await blob.text();
    if (text.startsWith('data:')) {
      triggerBlobDownload(dataUrlToBlob(text), fileName);
      return;
    }
  }
  triggerBlobDownload(blob, fileName);
}

export function* fetchClaimDocumentDownloadUrlResponseSaga(
  action: WsResponse<GetClaimAttachmentDownloadUrlResponse>,
): SagaIterator {
  const { downloadUrl, fileName, key } = action.payload;
  if (key) {
    yield put(clearOrderClaimAttachmentDownloading(key));
  }
  try {
    const response: Response = yield call(fetch, downloadUrl);
    if (response.ok) {
      yield call(resolveClaimAttachmentBlob, response, fileName);
    } else {
      yield call(
        notifyTop,
        'error',
        AppTranslation.t('common.file_download.error', 'File download failed'),
        'Unable to download file.',
      );
    }
  } catch (error) {
    console.info('File download failed:', error);
    yield call(
      notifyTop,
      'error',
      AppTranslation.t('common.file_download.error', 'File download failed'),
      'Unable to download file.',
    );
  }
}

export function* reAddOrderReferencesToBasketResponseSaga(
  action: WsResponse<ReAddOrderReferencesToBasketResponse>,
): SagaIterator {
  if (action.payload) {
    const { orderId, result } = action.payload;
    yield put(removeOrderIdFromPendingAddToBasketRequests(orderId));

    if (result) {
      notifyTop(
        'success',
        AppTranslation.t('my_orders.details.reAddOrderedReferences.success.title', 'Added to Basket'),
        AppTranslation.t(
          'my_orders.details.reAddOrderedReferences.success.description',
          'Your references have been successfully added to your basket.',
        ),
      );
    } else {
      notifyTop(
        'error',
        AppTranslation.t('my_orders.details.reAddOrderedReferences.failure.title', 'Failed to add to basket'),
        AppTranslation.t(
          'my_orders.details.reAddOrderedReferences.failure.description',
          'Unable to add references to your basket. Please try again',
        ),
      );
    }
  }
}

export function* getGarageUsersWithOrderRequestSaga(): SagaIterator {
  yield put(sendGetGarageUsersWithOrderRequest());
}

export function* getGarageUsersWithOrderResponseSaga(
  action: WsResponse<GetGarageUsersWithOrderResponse>,
): SagaIterator {
  yield put(setGarageUsersWithOrder(action.payload.garageUsersWithOrder));
}

export function* orderSubscriptionSaga({ payload }: ReturnType<typeof actions.orderSubscriptionSaga>): SagaIterator {
  if (!payload?.loadMore) {
    yield put(resetInProgressOrdersForNewSearch());
  }
  yield put(setInProgressIsLoading(true));
  const sortOption = yield* select(getInProgressOrdersSort);
  const sort = sortOptionsMapping.get(sortOption ?? 'DATE_DESC');
  const filters = yield* select(getAllInProgressOrdersFilters);
  const andFilter = new FilterArray<FilterAndSortField>('AND', filters);

  const cursor = payload?.loadMore ? yield* select(getInProgressOrdersCursor) : undefined;

  const filterAndSort: FilterAndSort<FilterAndSortField> = {
    filter: andFilter,
    sorts: sort ? [sort] : [],
    cursor,
  };

  yield put(sendSubscribeOrderUpdates({ filterAndSort }));
}

export function* orderUnsubscribeSaga(): SagaIterator {
  yield put(sendUnsubscribeOrderUpdates());
}

export function* orderStatusUpdateResponseSaga(action: WsResponse<OrderStatusUpdateResponse>): SagaIterator {
  if (action.payload) {
    yield put(updateOrderStatus(action.payload));
  }
}

export function* fetchVehicleInfoForClaimByVrnRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchVehicleInfoForClaimByVrnRequestSaga>): SagaIterator {
  const { vrn } = payload;
  const userCountry = yield* select(getUserCountry);
  const userContext = yield* select(getUserContext);
  const requestId = uuidv4();
  const country = Country.findByKey(userCountry) ?? DEFAULT_COUNTRY;
  yield put(setVrnSearchLoading(true));
  yield put(sendGetVehicleInfoByVrnRequest({ vrn, userContext, requestId, countryCode: country.key }));
}

export function* fetchVehicleInfoForClaimByVrnResponseSaga(action: WsResponse<GetVehicleInfoResponse>): SagaIterator {
  const { vehicles } = action.payload;
  yield put(setVrnSearchLoading(false));
  if (!vehicles || vehicles.length === 0) {
    return;
  }
  const vehicle = vehicles[0];
  const claimForm = yield* select(getOrderClaimForm);
  yield put(
    setOrderClaimForm({
      ...claimForm,
      vehicle: {
        ...claimForm.vehicle,
        vrn: vehicle.vrn || '',
        registrationDate: vehicle.registrationDate,
        brand: vehicle.vehicleBrand,
        model: vehicle.model,
        energy: vehicle.energyType,
        engineCode: vehicle.engineCode,
      },
    }),
  );
}

export function* OrderSagas(): SagaIterator {
  yield takeEvery(actions.checkoutOrderRequestSaga.type, sagaGuard(checkoutOrderRequestSaga));
  yield takeEvery(actions.checkoutOrderResponseSaga.type, sagaGuard(checkoutOrderResponseSaga));
  yield takeEvery(actions.downloadDealerOrdersRequestSaga.type, sagaGuard(downloadDealerOrdersRequestSaga));
  yield takeEvery(actions.fetchOrderByIdRequestSaga.type, sagaGuard(fetchOrderByIdRequestSaga));
  yield takeEvery(actions.fetchOrderByIdResponseSaga.type, sagaGuard(fetchOrderByIdResponseSaga));
  yield takeEvery(
    actions.reAddOrderReferencesToBasketRequestSaga.type,
    sagaGuard(reAddOrderReferencesToBasketRequestSaga),
  );
  yield takeEvery(
    actions.reAddOrderReferencesToBasketResponseSaga.type,
    sagaGuard(reAddOrderReferencesToBasketResponseSaga),
  );

  yield takeEvery(actions.fetchDealerOrdersResponseSaga.type, sagaGuard(fetchDealerOrdersResponseSaga));
  yield takeEvery(actions.fetchDealerExternalOrdersRequestSaga.type, sagaGuard(fetchDealerExternalOrdersRequestSaga));
  yield takeEvery(actions.fetchDealerExternalOrdersResponseSaga.type, sagaGuard(fetchDealerExternalOrdersResponseSaga));
  yield takeEvery(actions.sendOrderClaimRequestSaga.type, sagaGuard(sendOrderClaimRequestSaga));
  yield takeEvery(actions.subscribeSap2bClaimMessages.type, sagaGuard(subscribeSap2bClaimMessages));
  yield takeEvery(actions.subscribeSap2bClaimMessagesResponse.type, sagaGuard(subscribeSap2bClaimMessagesResponse));
  yield takeEvery(actions.fetchClaimsRequestSaga.type, sagaGuard(fetchClaimsRequestSaga));
  yield takeEvery(actions.fetchClaimsResponseSaga.type, sagaGuard(fetchClaimsResponseSaga));
  yield takeEvery(actions.fetchAscOrdersRequestSaga.type, sagaGuard(fetchAscOrdersRequestSaga));
  yield takeEvery(actions.fetchAscOrdersResponseSaga.type, sagaGuard(fetchAscOrdersResponseSaga));
  yield takeEvery(
    actions.fetchClaimDocumentUploadUrlRequestSaga.type,
    sagaGuard(fetchClaimDocumentUploadUrlRequestSaga),
  );
  yield takeEvery(
    actions.fetchClaimDocumentUploadUrlResponseSaga.type,
    sagaGuard(fetchClaimDocumentUploadUrlResponseSaga),
  );
  yield takeEvery(
    actions.fetchClaimDocumentDownloadUrlRequestSaga.type,
    sagaGuard(fetchClaimDocumentDownloadUrlRequestSaga),
  );
  yield takeEvery(
    actions.fetchClaimDocumentDownloadUrlResponseSaga.type,
    sagaGuard(fetchClaimDocumentDownloadUrlResponseSaga),
  );
  yield takeEvery(actions.getGarageUsersWithOrderRequestSaga.type, sagaGuard(getGarageUsersWithOrderRequestSaga));
  yield takeEvery(actions.getGarageUsersWithOrderResponseSaga.type, sagaGuard(getGarageUsersWithOrderResponseSaga));
  yield takeEvery(actions.fetchMyClientsOrdersRequestSaga.type, sagaGuard(fetchMyClientsOrdersRequestSaga));
  yield takeEvery(actions.fetchMyClientsOrdersResponseSaga.type, sagaGuard(fetchMyClientsOrdersResponseSaga));
  yield takeEvery(actions.fetchMyClientsOrderDetailRequestSaga.type, sagaGuard(fetchMyClientsOrderDetailRequestSaga));
  yield takeEvery(actions.fetchMyClientsOrderDetailResponseSaga.type, sagaGuard(fetchMyClientsOrderDetailResponseSaga));
  yield takeEvery(
    actions.updateMyClientsOrdersFiltersAndRefetchSaga.type,
    sagaGuard(updateMyClientsOrdersFiltersAndRefetchSaga),
  );
  yield takeEvery(actions.fetchExadisReturnListRequestSaga.type, sagaGuard(fetchExadisReturnListRequestSaga));
  yield takeEvery(actions.fetchExadisReturnListResponseSaga.type, sagaGuard(fetchExadisReturnListResponseSaga));
  yield takeEvery(actions.addExadisReturnListItemRequestSaga.type, sagaGuard(addExadisReturnListItemRequestSaga));
  yield takeEvery(actions.addExadisReturnListItemResponseSaga.type, sagaGuard(addExadisReturnListItemResponseSaga));
  yield takeEvery(
    actions.removeExadisReturnListItemsRequestSaga.type,
    sagaGuard(removeExadisReturnListItemsRequestSaga),
  );
  yield takeEvery(
    actions.removeExadisReturnListItemsResponseSaga.type,
    sagaGuard(removeExadisReturnListItemsResponseSaga),
  );
  yield takeEvery(actions.fetchDepositReturnListRequestSaga.type, sagaGuard(fetchDepositReturnListRequestSaga));
  yield takeEvery(actions.fetchDepositReturnListResponseSaga.type, sagaGuard(fetchDepositReturnListResponseSaga));
  yield takeEvery(actions.addDepositReturnListItemRequestSaga.type, sagaGuard(addDepositReturnListItemRequestSaga));
  yield takeEvery(actions.addDepositReturnListItemResponseSaga.type, sagaGuard(addDepositReturnListItemResponseSaga));
  yield takeEvery(
    actions.removeDepositReturnListItemsRequestSaga.type,
    sagaGuard(removeDepositReturnListItemsRequestSaga),
  );
  yield takeEvery(
    actions.removeDepositReturnListItemsResponseSaga.type,
    sagaGuard(removeDepositReturnListItemsResponseSaga),
  );
  yield takeEvery(actions.orderSubscriptionSaga.type, sagaGuard(orderSubscriptionSaga));
  yield takeEvery(actions.orderUnsubscribeSaga.type, sagaGuard(orderUnsubscribeSaga));
  yield takeEvery(actions.orderStatusUpdateResponseSaga.type, sagaGuard(orderStatusUpdateResponseSaga));
  yield takeEvery(
    actions.fetchVehicleInfoForClaimByVrnRequestSaga.type,
    sagaGuard(fetchVehicleInfoForClaimByVrnRequestSaga),
  );
  yield takeEvery(
    actions.fetchVehicleInfoForClaimByVrnResponseSaga.type,
    sagaGuard(fetchVehicleInfoForClaimByVrnResponseSaga),
  );
}
